export default {
  data() {
    return {
      showLogo: false,
    };
  },
  methods: {
    goTo(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path);
      }
    },
    isActiveRoute(path) {
      return this.currentRoutePath.replace(/\/$/, '') === path;
    },
  },
  mounted() {
    document.onkeydown = (e) => {
      e = e || window.event;

      if (e.keyCode === 27) {
        this.$store.dispatch('SHOW_SIDEBAR', false);
      }
    };
  },
};
